import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { LoginResponse } from "../model/response/auth-r";
import { MicrosoftAuthLoginRequest } from "../model/microsoft-auth/microsoft-auth";
import { BaseResponse } from "../model/response/base-response";


@Injectable({
    providedIn: 'root'
})
export class MicrosoftAuthService {

    private url: string = `${environment.apiUrl}/mc-stuff`;

    constructor(private http: HttpClient) {

    }

    loginMicrosoft(request: MicrosoftAuthLoginRequest): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(`${this.url}/login`, request);
    }

    deleteMicrosoftConn(accountId: number): Observable<BaseResponse> {
        return this.http.delete<BaseResponse>(`${this.url}/${accountId}`);
    }


}